import { render, staticRenderFns } from "./PCard.vue?vue&type=template&id=6eadbf9a&scoped=true&"
var script = {}
import style0 from "./PCard.vue?vue&type=style&index=0&id=6eadbf9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eadbf9a",
  null
  
)

export default component.exports